import { render, staticRenderFns } from "./changedate.vue?vue&type=template&id=2ab882a4&"
import script from "./changedate.vue?vue&type=script&lang=js&"
export * from "./changedate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports